<template>
	<div :class="{ 'detail-footer': true, radius }">
		<div class="m-top m-center">
			<div class="mandy-icon">
				<div class="mandy-border">
					<img src="../assets/img/group-mandy.png" alt="" />
				</div>
				<div class="mandy-text">			
					<span class="mandy-primary-text">{{ info.name }}</span>
					<span>({{ info.describe }})</span>
					
				</div>
			</div>
		</div>
		<div>
			<div class="m-top m-field">
				<img src="../assets/img/message.png" alt="" style="width: 20px;height: 20px;"/>
				<span class="m-text">{{ info.email }}</span>
			</div>
			<div class="m-top m-field">
				<img src="../assets/img/stroke-1.png" alt="" />
				<span class="m-text">{{ info.mobile }}</span>
			</div>
		</div>
		<div class="m-top m-field">
			<img src="../assets/img/we-chat-logo-icon-1.png" alt="" />
			<span class="m-text" id="mtext">{{ info.wechat }}</span>
		</div>
		<div class="m-top m-center">
			<div class="qr-code">
				<img :src="info.qr_code" alt="" />
			</div>
		</div>
		<div style="text-align:center;margin:10px 0">请扫码添加顾问老师微信</div>
	</div>
</template>

<script>
	import { getUser } from '../store/user';
	export default {
		name: 'WpMandyMini',
		props: {
			radius: Boolean,
		},
		data() {
			return {
				info: {
					name: '',
					describe: '',
					email: '',
					mobile: '',
					wechat: '',
					qr_code: '',
				},
			};
		},
		mounted() {
			let user = getUser();
			this.info = user.salesperson_info;
		},
	};
</script>

<style lang="less" scoped>
	.detail-footer {
		background-color: white;
		border: 1px solid #e8e8e8;
		width: 100%;
		padding-bottom: 36px;

		> * {
			width: 100%;
		}

		> *:not(.m-center) {
			text-align: left;
			padding-left: 50px;
		}
	}

	.mandy-primary-text {
		font-weight: 600;
		font-size: 1.28rem;
	}

	.mandy-text {
		span {
			display: block;
		}
	}

	.qr-code {
		height: 103px;
		width: 103px;
		line-height: 103px;
		background: #B50604;
		border-radius: 4px;
		margin: auto;
		img {
			width: 95px;
			height: 95px;
			vertical-align: middle;
		}
	}

	.mandy-border {
		width: 80px;
		height: 80px;
		border-radius: 40px;
		margin: auto;
		background: #eaf5ff;
		display: inline-block;
		line-height: 80px;

		img {
			vertical-align: middle;
			max-width: 100%;
		}
	}

	.radius {
		border-radius: 18px;
		box-shadow: 0px 6.66332px 26.6533px rgba(0, 0, 0, 0.08);
	}

	.m-top {
		margin-top: 20px;
	}

	.m-center {
		text-align: center;
	}

	.m-text {
		display: inline-block;
		font-weight: 600;
		font-size: 1.2rem;
	}

	.m-field {
		vertical-align: middle;

		img {
			line-height: 20px;
			vertical-align: middle;
		}

		> span {
			display: inline-block;
			// width: 220px;
			text-align: left;
			margin-left: 20px;
		}
	}

	.detail-footer {
		margin: 30px auto 0;
		// width: 1076px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around;
		flex-wrap: wrap;
	}
	// 移动端
	@media screen and (max-width: @device) {
		.mandy-text{
			span{

				font-family: Poppins;
				font-size: 14px;
				font-weight: 400;
				line-height: 20px;
				letter-spacing: 0em;
				text-align: center;

			}
			.mandy-primary-text{
			margin-top: 10px;
			font-weight: 600;
			font-size: 20px;
			line-height: 20px;
			color: #0B1D33;
			margin-bottom: 8px;
			}	
			
		}
	.m-text{
		font-weight: 600;
		font-size: 18px;
		line-height: 17px;
		color: #0B1D33;
			}
	// #mtext{
	// 	font-weight: 400;
	// 	font-size: 16px;
	// 	line-height: 17px;
	// 		}
	}
</style>


// WEBPACK FOOTER //
// src/components/WpMandyMini.vue